module.exports = __webpack_public_path__ + "static/media/bg-3.09e5978c.png";